<h2 mat-dialog-title>{{ data.title || 'Processing' }}</h2>
<mat-dialog-content>
    <div class="ado-processing-content">
        <app-spinner [isLoading]="true" diameter="42" [showText]="false"></app-spinner>
        <p class="ado-processing-message">{{ data.message || 'Creating Azure DevOps feature and attaching report. Please wait...' }}</p>
    </div>
</mat-dialog-content>
